import { ApiQuery, SortDirections } from "../filters/types";
import { TokenHoldersColumns } from "./types";

// // // //

export const DEFAULT_TOKEN_HOLDERS_LIST_QUERY: ApiQuery = {
    sort: {
        direction: SortDirections.desc,
        field: TokenHoldersColumns.holdingTokenValueUSD,
    },
    pagination: {
        page: 1,
        perPage: 15,
    },
};
